import { ChatMessage } from "@/entities/messaging/types";

export const isSameMessage = (
  messageA: ChatMessage,
  messageB: ChatMessage
): boolean => {
  return messageA.id === messageB.id;
};

export const messagesCompareFn = (a: ChatMessage, b: ChatMessage): number =>
  parseInt(a.timestamp, 10) - parseInt(b.timestamp, 10);
